import React, { Component } from 'react';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import Router from '../router';

class AppContainer extends Component {
  static propTypes = {
    appConfig: PropTypes.object,
    integrations: PropTypes.object,
    embeddedIntegrations: PropTypes.object,
    biLogger: PropTypes.object,
  };

  componentDidMount = () => {
    this.props.biLogger.openApp();
    this.props.embeddedIntegrations.initStoreData();
  };

  render() {
    const {
      appConfig: { experiments, basename },
      integrations: { areIntegrationsReady },
      embeddedIntegrations: { areEmbeddedIntegrationsReady },
    } = this.props;

    return (
      areEmbeddedIntegrationsReady &&
      areIntegrationsReady && (
        <ExperimentsProvider options={{ experiments }}>
          <Router basename={basename} />
        </ExperimentsProvider>
      )
    );
  }
}

export default inject(
  'appConfig',
  'integrations',
  'embeddedIntegrations',
  'biLogger',
)(observer(AppContainer));
